export const ADVANCED_SETTINGS = 'ADVANCED_SETTINGS';
export const ADVANCED_SETTINGS_MODAL = 'ADVANCED_SETTINGS_MODAL';
